import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllPrincipleEntities = lazy(() =>
  import("../pages/all-principle-entities")
);

export const PrincipleEntityManagementRouter = [
  {
    path: "/master-management/principal-entity",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllPrincipleEntities />
          </Suspense>
        ),
      },
      {
        path: ":id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllPrincipleEntities />
          </Suspense>
        ),
      },
    ],
  },
];
